import React from 'react'
import './Steps.css'
import { Link } from 'react-router-dom'

function Steps() {
return (
    <div className='steps-section'>
        <div className='steps-info'>
            <div>
                <h2 className='header2'>Ready for caring postpartum support?</h2>
                <p className='grey' style={{ lineHeight: '40px' }}>
                    A free consultation is the first step toward feeling supported, confident, and fully prepared for your path into parenthood.
                </p>
            </div>
            <div>
                <h3 className='header3'>What do the next steps entail?</h3>
                <ol style={{ lineHeight: '40px' }}>
                    <li className='grey'>Talk with a family consultant — review your postpartum needs and find the services that suit you.</li>
                    <li className='grey'>Meet potential doulas — connect and interview doulas to choose the best match.</li>
                    <li className='grey'>Reserve your doula — secure the doula you want and begin your supported journey with confidence.</li>
                </ol>
            </div>
        </div>
        <div className='form-section'>
            <Link to='/inquiry' className=' button text-decoration-none'>
               Inquire About Services
            </Link>
        </div>
    </div>
)
}

export default Steps